export default __webpack_public_path__ + "static/media/Cutting-edge_HSC_Research_flyer.49dc44f8.pdf";